<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
import axios from "axios";

export default {
  beforeCreate() {
    var user = window.localStorage.getItem("user");

    if (user) {
      user = JSON.parse(user);
      console.log("Oturumu açık kullanıcı: ", user);
      this.$root.$data.login = user;
      this.$store.commit("setUser", user);
      axios.defaults.headers.common["token"] = user.Key;
      axios.defaults.headers.common["account"] = this.$route.params.accountCode;
      this.$router.push("/index");
    }
  },
  data() {
    return {};
  },
  methods: {}
};
</script>
<style></style>
